import accountComponents from './account/index';

const components = {
  ...accountComponents
};

export class AuthComponents {
  static install (Vue) {
    registerComponents(Vue, components);
  }
}

function registerComponents (Vue, components) {
  for (const component in components) {
    registerComponent(Vue, component, components[component]);
  }
}

function registerComponent (Vue, name, def) {
  Vue._leica_auth_components_ = Vue._leica_auth_components_ || {};
  const loaded = Vue._leica_auth_components_[name];
  if (!loaded && def && name) {
    Vue._leica_auth_components_[name] = true;
    Vue.component(def.name || name, def);
  }
  return loaded;
}
